import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import img67 from '../EquipoMedico/img67.jpg'
import img68 from '../EquipoMedico/img68.jpg'

export class Operations extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>Operating Room</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos 2 columnas para que la información detallada de los equipos
                        de cirugía sea perfectamente legible */}
                    <Row className="justify-content-center g-4">
                        <Col xs={12} lg={6}>
                            <Card className="shadow-sm border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img67} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Operating Room Equipment I</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>

                        <Col xs={12} lg={6}>
                            <Card className="shadow-sm border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img68} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Operating Room Equipment II</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}